<template>
  <NotificationText v-bind="$props">
    <template #primary>
      <i>{{notification.data.senderName}}</i> hat eine Datei freigegeben.
    </template>
    <template #detail-content>
      <PeerFiles
        :files="[notification.data.file]"
        :description="notification.data.file.description"
      />
    </template>
    <template #actions-prepend>
      <v-btn
        small
        text
        color="accent"
        target="_blank"
        :to="relativeURL(notification.data.file.url)"
        @click="markRead"
      >Datei herunterladen</v-btn>
    </template>
  </NotificationText>
</template>

<script>
  import NotificationTextMixin from '../notification-text-mixin';
  import PeerFiles from '../../peers/PeerFiles';


  export default {
    name: 'FilePublicDownload',

    components: {
      PeerFiles
    },

    mixins: [
      NotificationTextMixin
    ]
  };
</script>
